import { Link } from '@tanstack/react-router'
import { CalendarDays, UserRound } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import type { RenderedTask } from './render-data-payload'

function displayStatus(status: string) {
  return status.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ')
}

function displayDueDate(value: string) {
  const [year, month, day] = value.split('-').map(Number)
  if (!year || !month || !day) return value
  return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' }).format(
    new Date(year, month - 1, day)
  )
}

export function TaskEntityCard({ task }: { task: RenderedTask }) {
  return (
    <Link
      to="/tasks"
      data-slot="entity-card"
      data-entity-type="task"
      className="block rounded-lg border p-3 transition-colors hover:bg-muted/50"
    >
      <div className="space-y-2">
        <div className="flex items-start justify-between gap-2">
          <p className="min-w-0 truncate text-sm font-medium">{task.title}</p>
          <Badge variant="outline" className="shrink-0">
            {displayStatus(task.status)}
          </Badge>
        </div>
        <div className="space-y-1 text-xs text-muted-foreground">
          <div className="flex items-center gap-1.5">
            <CalendarDays className="size-3 shrink-0" />
            <span>Due {displayDueDate(task.dueDate)}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <UserRound className="size-3 shrink-0" />
            <span className="truncate">{task.assignee || 'Unassigned'}</span>
          </div>
          {task.parentLabel && <p className="truncate">{task.parentLabel}</p>}
        </div>
      </div>
    </Link>
  )
}
